import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const ruleList = createAsyncThunk('rule/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `premise_rules`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'premise_id': data?.premise_id,
                'status': data?.status,
                'rule_type': data?.rule_type,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const ruleDetails = createAsyncThunk('rule/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `premise_rules/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addRule = createAsyncThunk('rule/add', async (data) => {

    const bodyFormData = new FormData()

    bodyFormData.append("premise_id", data?.values?.premise_id)
    bodyFormData.append("rule_name", data?.values?.title)
    bodyFormData.append("description", data?.values?.description)
    bodyFormData.append("status", data?.values?.status ?? 'Active')
    bodyFormData.append("rule_type", data?.values?.rule_type)

    if (data?.values?.attachments && Array.isArray(data?.values?.attachments)) {
        data.values.attachments.forEach((file) => {
            bodyFormData.append("rule_file", file);
        });
    }

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'premise_rules',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "type": "rule_file", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateRule = createAsyncThunk('rule/update', async (data) => {

    const bodyFormData = new FormData()

    bodyFormData.append("rule_id", data?.values?.id)
    bodyFormData.append("premise_id", data?.values?.premise_id)
    bodyFormData.append("rule_name", data?.values?.title)
    bodyFormData.append("description", data?.values?.description)
    bodyFormData.append("status", data?.values?.status ?? 'Active')
    bodyFormData.append("rule_type", data?.values?.rule_type)

    if (data?.values?.attachments && Array.isArray(data?.values?.attachments)) {
        data.values.attachments.forEach((file) => {
            bodyFormData.append("rule_file", file);
        });
    }

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'update_premise_rules',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "type": "rule_file", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delRule = createAsyncThunk('rule/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `premise_rules/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delRuleFile = createAsyncThunk('rule/deleteFile', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `rule_file/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const rule = createSlice({
    name: 'rule',
    initialState: {
        list: [],
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ruleList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });

        builder.addCase(ruleDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });
    }
})

export default rule.reducer;